import React from 'react';
import { CTAButton } from '../components/CTAButton';
import { SectionReveal } from '../components/SectionReveal';
import { ZapIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-brand-darker" style={{
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f2744 100%)'
  }} data-id="element-115">
      {/* Background effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-brand-darker/50 via-brand-dark/50 to-brand-darker/50" data-id="element-116" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-blue-500/5 rounded-full blur-3xl" data-id="element-117" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-emerald-500/5 rounded-full blur-3xl" data-id="element-118" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 py-20 text-center" data-id="element-119">
        <SectionReveal data-id="element-120">
          <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/25 rounded-full px-5 py-2 mb-8" data-id="element-121">
            <ZapIcon className="w-5 h-5 text-emerald-400" aria-hidden="true" data-id="element-122" />
            <span className="text-emerald-400 font-body text-sm font-semibold uppercase tracking-wider" data-id="element-123">
              BAJÁ TU FACTURA HASTA UN 60%
            </span>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.1} data-id="element-124">
          <h1 className="font-heading font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.1] mb-6 text-shimmer tracking-[-0.02em]" data-id="element-125">
            ESTÁS PAGANDO DE MÁS EN LA LUZ (Y NO LO SABÉS)
          </h1>
        </SectionReveal>

        <SectionReveal delay={0.2} data-id="element-126">
          <p className="text-lg sm:text-xl md:text-2xl text-gray-200 font-body leading-relaxed max-w-3xl mx-auto mb-4" data-id="element-127">
            Descubrí cómo bajar tu factura hasta un 60% en Argentina, sin
            conocimientos técnicos y de forma 100% legal.
          </p>
          <p className="text-base sm:text-lg text-gray-300 font-body mb-8" data-id="element-128">
            Más de 3.000 personas ya lo están aplicando en todo el país
          </p>
        </SectionReveal>

        <SectionReveal delay={0.3} data-id="element-129">
          <p className="font-body text-center mb-10" style={{
          color: '#94a3b8',
          fontSize: '14px'
        }} data-id="element-130">
            ✔ Acceso inmediato • ✔ Garantía 15 días • ✔ Funciona en toda
            Argentina
          </p>
        </SectionReveal>

        <SectionReveal delay={0.4} data-id="element-131">
          <CTAButton text="QUIERO BAJAR MI FACTURA AHORA" size="xl" scrollTo="oferta" data-id="element-132" />
        </SectionReveal>

        {/* Decorative bottom fade */}
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-brand-dark to-transparent" data-id="element-133" />
      </div>
    </section>;
}